import { Skeleton } from "@mui/material";
import IndieStaticSelect from "components/forms/IndieStaticSelect";
import { TariffsContext } from "contexts/tariffs/TariffsContext";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import React from 'react';

const TariffPlansSelect = React.memo(({ product, energy_transaction, energyTransactionCode, label, ...params }) => {
    
    const [values, setValues] = useState([]);
    const { t } = useTranslation();
    const { getProductPlans } = useContext(TariffsContext);
    const [loading, setLoading] = useState(false);

    const fetchValues = () => {
        if (loading) return;
        setLoading(true);
        getProductPlans(product, energy_transaction, energyTransactionCode).then((response) => {
            setValues(response.map((plan) => ({
                value: plan.id,
                label: t(`${plan.description}`),
                code: plan.code,
                "use_energy_price": plan.use_energy_price,
                "use_commission_prcnt": plan.use_commission_prcnt,
                "use_commission_total": plan.use_commission_total
            })));
            setLoading(false);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
        });

    }

    useEffect(() => {
        if (product) {
            fetchValues();
        }
    }, [product])

    useEffect(() => {
        if(product) {
            fetchValues();
        }
    }, [])

    if (loading) {
        return (
            <Skeleton variant="rectangular" height={50} />
        )
    }
    return (
        <IndieStaticSelect
            {...params}
            options={values}
            label={t(label) || t("label.table.header.energyTariff")}
            sx={{width:400}}
        />
    );

});

export default TariffPlansSelect;